import React from 'react';
import { observer } from 'mobx-react';
import Icon from '@mdi/react';
import { mdiAsterisk } from '@mdi/js';
import { InformationModalIcon } from '../InformationModal/InformationModal';
import { StaticTooltip } from '../StaticTooltip/StaticTooltip';

interface IInput {
  label?: string;
  elementLabel?: any;// passing an element for html additions
  idAndName: string;
  valid: boolean;
  required?: boolean;
  asterisk?: boolean;
  value: any;
  type: string;
  errorMsg?: string;
  className?: string;
  unitLabel?: string;
  onChange: (event: {}) => void;
  onBlur?: (event: { target: any }) => void;
  onKeyDown?: (event: {}) => void;
  onFocus?: (event: { target: any }) => void;
  autofocus?: boolean;
  step?: string | number;
  disabled?: boolean;
  infoIcon?: boolean;
  infoText?: string;
  infoIconCallback?: () => void;
  wrapperClassName?: string;
  placeholder?: string;
  min?: number;
  readOnly?: boolean;
  ariaLabel?: string;// for different label if screen reader doesn't read the label right
  // Input Help Modal Trigger button
  helpIcon?: boolean;
  helpIconCallback?: () => void;
  externalLabel?: string;
}
const InputComponent = (props: IInput) => {
  return (
    <div className={'common-input-container ' + props.wrapperClassName}>
      <label className={"usa-label "} htmlFor={props.idAndName}>
        {props.label}{props.required && props.asterisk ? <Icon path={mdiAsterisk} size={0.4} color="red" className='required-input-icon' /> : null}
        {props.elementLabel}
        {props.helpIcon && props.helpIconCallback !== undefined ? (
          <InformationModalIcon modalTriggerCallback={props.helpIconCallback} title={props.label!} />
        ) : null}
        {props.infoText && props.infoIconCallback !== undefined ? (
          <StaticTooltip tooltipMessage={props.infoText} tooltipSide='left' id={`tooltip-${props.idAndName}`} />
        ) : null}
      </label>
      <input
        className={'usa-input ' + props.className}
        id={props.idAndName}
        data-testid="the-Input"
        name={props.idAndName}
        aria-invalid={!props.valid}
        aria-describedby={props.idAndName + '--err ' + props.idAndName + '--units'}
        aria-required={props.required}
        aria-label={props.ariaLabel}
        type={props.type}
        value={props.value}
        onChange={props.onChange}
        onBlur={(e) => {
          if (props.onBlur) props.onBlur(e);
        }}
        autoFocus={props.autofocus}
        onKeyDown={props.onKeyDown}
        onFocus={props.onFocus}
        step={props.step}
        disabled={props.disabled}
        placeholder={props.placeholder}
        min={props.min}
        readOnly={props.readOnly}
        aria-readonly={props.readOnly}
        aria-labelledby={props.externalLabel}
      />
      <span className="metric-units" id={props.idAndName + '--units'} hidden={!props.unitLabel}>
        {props.unitLabel}
      </span>
      <span
        className="usa-error-message"
        id={props.idAndName + '--err'}
        role="alert"
        hidden={!props.errorMsg}
        aria-live="polite"
      >
        {props.errorMsg}
      </span>
    </div>
  );
};

export const Input = observer(InputComponent);
